module.exports = __webpack_public_path__ + "static/media/de_skrivhastighet_video.3ddc1bea.mp4";